<template>
  <section
    :class="containerClasses"
    data-ui="member-promo-group"
  >
    <div
      v-if="heading"
      class="member-promo-group__meta"
    >
      <cdr-text tag="h2">
        {{ heading }}
      </cdr-text>
      <cdr-text
        v-if="subheading"
      >
        {{ subheading }}
      </cdr-text>
    </div>
    <cdr-list
      v-if="groups && groups.length"
      data-ui="member-promo-group-promos"
      class="member-promo-group__promos-wrapper"
    >
      <li
        v-for="(group, i) in groups"
        :key="i"
      >
        <template v-if="group.length === 1">
          <member-promo
            v-bind="group[0]"
            :promo-count="1"
            :promo-theme="theme"
            :row="i + 1"
            :membership-in-cart="membershipInCart"
            @success="$emit('success')"
          />
        </template>
        <template v-else>
          <cdr-list class="member-promo-group__promos-wrapper">
            <li
              v-for="({ key, ...props }) in group"
              :key="key"
            >
              <member-promo
                v-bind="props"
                :promo-count="groups.length"
                :promo-theme="theme"
                :membership-in-cart="membershipInCart"
                @success="$emit('success')"
              />
            </li>
          </cdr-list>
        </template>
      </li>
    </cdr-list>
  </section>
</template>

<script>
import { CdrList, CdrText } from '@rei/cedar';
import MemberPromo from './MemberPromo.vue';

export default {
  name: 'MemberPromoGroup',
  components: {
    CdrText,
    CdrList,
    MemberPromo,
  },
  props: {
    heading: {
      type: String,
      required: false,
      default: '',
    },
    membershipInCart: {
      type: Boolean,
      required: false,
      default: false,
    },
    groups: {
      type: Array,
      required: true,
    },
    subheading: {
      type: String,
      required: false,
      default: '',
    },
    theme: {
      type: String,
      required: false,
      default: '',
    },
  },
  /* c8 ignore start */
  emits: ['success'],
  /* c8 ignore end */
  computed: {
    containerClasses() {
      return [
        'member-promo-group',
        this.theme && `member-promo-group--theme-${this.theme}`,
      ];
    },
  },
};
</script>

<style lang="scss">
.member-promo-group {
  @include cdr-container;
  padding-top: $cdr-space-two-x;
  margin-bottom: $cdr-space-three-x;

  &.member-promo-group__theme-sale {
    .member-promo__meta {
      h2 {
        color: $cdr-color-text-sale;
      }
    }
  }
  @include cdr-md-mq-up {
    padding-top: $cdr-space-three-x;
  }
  @include cdr-lg-mq-up {
    margin-bottom: $cdr-space-four-x;
  }
}

.member-promo-group__meta {
  width: 100%;
  text-align: center;
  margin-bottom: $cdr-space-two-x;

  @include cdr-md-mq-up {
    margin-bottom: $cdr-space-three-x;
  }

  h2 {
    @include cdr-text-heading-serif-800;
    color: $cdr-color-text-primary;
    margin-bottom: $cdr-space-one-x;
  }
  p {
    @include cdr-text-body-300;
    margin-bottom: 0;
  }
  a {
    @include cdr-link-base-mixin;
  }
}

.member-promo-group__promos-wrapper {
  display: grid;
  grid-gap: $cdr-space-three-x;

  // these importants override some deeply-nested cdr-grid styles
  margin: 0!important;
  padding: 0!important;
  li {
    margin-top: 0!important;
  }

  @include cdr-sm-mq-up {
    grid-column-gap: $cdr-space-two-x;

    // nested promo wrapper occurs in rows with more than one promo
    .member-promo-group__promos-wrapper {
      grid-auto-flow: column;
    }
  }

  @include cdr-lg-mq-up {
    grid-row-gap: $cdr-space-four-x;
  }
}
</style>
